import http from "./httpService"
import * as URL from "../../../constants/urls"

const performSearch = (searchTerm) =>
  new Promise((resolve) => {
    if (!searchTerm || searchTerm === "*") {
      searchTerm = ""
    }
    const result = http.get(URL.SITE_PREFIX + URL.TYPEAHEAD + searchTerm)
    resolve(result)
  })

const redirectToSearchpage = (searchTerm) => {
  if (searchTerm === "*") {
    searchTerm = ""
  }
  const url = URL.SEARCHPAGE + searchTerm + "/"
  window.location.href = url
}

export default {
  performSearch: performSearch,
  redirectToSearchpage: redirectToSearchpage,
}
